import Image from 'next/image';

interface ImageSize {
    sourceUrl: string;
    width: number;
}

interface CustomImageComponentProps {
    sourceUrl?: string;
    title?: string;
    sizes?: ImageSize[];
    className?: string;
    priority?: boolean;
}

const CustomImageComponent: React.FC<CustomImageComponentProps> = ({
    sourceUrl,
    title,
    sizes,
    className = '',
    priority = false,
}) => {
    const createSrcSet = (imageSizes: ImageSize[]): string => {
        return imageSizes.map(({ sourceUrl, width }) => `${sourceUrl} ${width}w`).join(', ');
    };

    const defaultFeaturedImage = '/images/cover-video.jpg';
    const defaultAlt = 'post-blog-alt';
    const hasFeaturedImage = !!sourceUrl;

    const imgSrc = hasFeaturedImage ? sourceUrl : defaultFeaturedImage;
    const imgAlt = hasFeaturedImage ? title : defaultAlt;

    return (
        <div className={`relative overflow-hidden rounded-lg ${className}`}>
            <Image
                fill={true}
                className='object-cover'
                src={imgSrc}
                title={imgAlt}
                alt={imgAlt || ''}
                sizes={sizes ? createSrcSet(sizes) : undefined}
                priority={priority}
            />
        </div>
    );
};

export default CustomImageComponent;
